<template>
  <div class="flex flex-col py-8 md:py-8 h-auto w-full items-center">
    <div class="max-w-[76rem] flex flex-col-reverse md:flex-row gap-5 py-4 md:py-6 px-4 md:px-8 w-[90%] md:w-[81%] h-auto md:h-[20rem] bg-GRIS_CLARO rounded-lg">
      <div class="flex flex-col gap-6 w-full md:w-1/2 justify-center px-0 md:px-5">
        <div class="flex flex-col gap-4 mx-auto w-full md:max-w-[500px] items-center justify-center text-center md:text-left">
          <p class="font-semibold text-base md:text-lg">¡Descubre nuestros increíbles locales y obtén asesoría de experto
            hoy mismo!</p>
          <h3 class="text-ROJO_LEON font-semibold text-lg md:text-2xl">Llama ahora y déjanos guiarte con tus dudas</h3>
          <button @click="openTelephone"
            class="bg-ROJO_LEON py-2 px-4 md:self-start rounded-lg text-white font-semibold transition-all flex gap-2 items-center group hover:bg-opacity-90">
            Ver locales
            <img src="/img/newhome/splitbanner/diagonal-arrow.svg" alt="ver-locales"
              class="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
      <!--lado derecho-->
      <div class="md:w-1/2 w-full relative map-container rounded-t-lg md:rounded-r-lg h-[12rem] md:h-full">
        <img src="/img/newhome/splitbanner/leon.webp" alt="leon"
          class="absolute bottom-0 right-0 md:right-4 w-[9rem] md:w-[13rem] aspect-auto" />
      </div>
    </div>
  </div>
</template>

<script setup>
function openTelephone() {
  const popup = document.getElementById('popupLocales')
  if (popup) {
    popup.classList.remove('hidden')
    popup.classList.add('flex')
  }
  document.body.style.overflow = 'hidden'
}
</script>

<style scoped>
.map-container {
  background: url('/img/newhome/splitbanner/locales-bg-desk.webp') no-repeat center;
  background-size: cover;
}

@media screen and (max-width: 768px) {
  .map-container {
    background: url('/img/newhome/splitbanner/locales-bg-mob.webp') no-repeat center;
    background-size: cover;
  }
}
</style>